/**
 * Bloco do Clube Hormonalle.
 *
 * Usa o gradiente da **Hormonalle**, não o da NOHRA: o conteúdo é da marca
 * irmã, e a `tailwind.config.ts` mantém as duas paletas separadas de propósito.
 * O ícone vai em chip branco pelo mesmo motivo do `CardAtalho` — o glifo é
 * magenta sobre transparente e sumiria contra o próprio gradiente.
 */
export function SecaoClube() {
  return (
    <section id="clube" className="scroll-mt-20 border-b border-border bg-background py-20">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="overflow-hidden rounded-2xl bg-gradient-hormonalle">
          <div className="grid items-center gap-8 p-8 sm:p-12 lg:grid-cols-[1.2fr_0.8fr]">
            <div>
              <div className="w-fit rounded-lg bg-white p-2 shadow-sm">
                <img
                  src="/icone-hormonalle.png"
                  alt=""
                  aria-hidden="true"
                  className="h-8 w-8 object-contain"
                />
              </div>

              <h2 className="mt-5 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                Clube Hormonalle
              </h2>
              <p className="mt-4 max-w-xl text-lg leading-relaxed text-white/85">
                Cupons e benefícios do programa de relacionamento da Hormonalle, dentro da mesma
                plataforma que você já usa para os seus pacientes.
              </p>
            </div>

            <ul className="space-y-3 text-white/90">
              <li className="rounded-lg border border-white/20 bg-white/10 px-4 py-3 text-sm backdrop-blur-sm">
                Vitrine filtrada pelo seu ranque no programa
              </li>
              <li className="rounded-lg border border-white/20 bg-white/10 px-4 py-3 text-sm backdrop-blur-sm">
                Aviso de cupom novo e de cupom prestes a expirar
              </li>
              <li className="rounded-lg border border-white/20 bg-white/10 px-4 py-3 text-sm backdrop-blur-sm">
                Produtos e materiais técnicos dos parceiros do ecossistema
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
